import { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
    // scrollToLast,
    connectMessage,
    login,
    pongMessage,
    isUserStatus,
    subscribeUserStatus,
    groupMessagesByDate,
    getSubscription,
    subscriptionUser
} from '@utils/helpers/chatHelpers'
import { RootState } from '@app-store/store'
import { rootActions } from '@app-store/slices'

export default function useWebsocket(url) {
    const dispatch = useDispatch()
    const { typing } = useSelector((state: RootState) => state.ui.chat)
    const [connected, setConnected] = useState<boolean>(false)
    const ws = useRef(null)

    // typing indicator
    useEffect(() => {
        ws.current = new WebSocket(url)

        ws.current.onopen = () => {
            connectMessage(ws)
            login(ws)
            subscribeUserStatus(ws)
            getSubscription(ws)
            subscriptionUser(ws, 'notification')

            // listening for messages
            ws.current.onmessage = evt => {
                const message = JSON.parse(evt.data)
                // connected message reciever
                if (message.msg === 'connected') {
                    setConnected(true)
                    // dispatch(setConnected(true));
                }

                if (message.msg === 'ping') {
                    pongMessage(ws)
                }
                if (message.msg === 'result' && message.id === '5') {
                    dispatch(rootActions.ui.chat.addMessage(message.result))
                    dispatch(rootActions.ui.common.addChatMessage(message.result))
                }
                // fetch history reciever
                if (message.msg === 'result' && message.id === '1') {
                    const history = groupMessagesByDate([...(message.result.messages || [])].reverse())
                    dispatch(rootActions.ui.chat.setMessages(history))

                    // scrollToLast(messageContainer)
                }

                if (message.msg === 'result' && message.id === '42' && message?.result?.update?.length) {
                    const unreads = message?.result.update.map(item => ({
                        roomId: item.rid || item._id,
                        count: item.unread
                    }))
                    dispatch(rootActions.ui.chat.setUnreads(unreads))
                }

                //group  message stream reciever
                else if (message.msg === 'changed' && message.collection === 'stream-room-messages') {
                    const {
                        fields: { args }
                    } = message
                    // typingIndicatorSub(ws, group._id);
                    if (args?.length) {
                        dispatch(rootActions.ui.chat.addMessage(args[0]))
                        dispatch(rootActions.ui.common.addChatMessage(args[0]))
                    }
                    // scrollToLast(messageContainer)
                } else if (isUserStatus(message)) {
                    const {
                        fields: { args }
                    } = message
                    args.forEach(arg => {
                        // setStatus(arg[0], arg[2]);
                    })
                } else if (
                    message.msg === 'changed' &&
                    message.collection === 'stream-notify-room' &&
                    message.id === 'id'
                ) {
                    const {
                        fields: { args }
                    } = message
                    const groupId = message.fields.eventName.split('/')[0]
                    typing !== args[1] &&
                        dispatch(rootActions.ui.chat.setTyping({ username: args[0], value: args[1], groupId }))
                }
                // rest undefined conditions
            }
        }

        return () => {
            ws.current.close()
        }
    }, [])

    return { connected, ws }
}
